// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3c8Iw","range":"MonthRangeSwitch_range__3c0-V","disabled":"MonthRangeSwitch_disabled__1q9Ge"};